module.exports = __webpack_public_path__ + "img/ml3050.ee631879.png";